// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3ToTF","header":"styles_header__1-SA_","closeButton":"styles_closeButton__1VIfk"};